import { Injectable } from '@angular/core';
import { EventsManagerService } from './events-manager.service';

@Injectable()
export class ConnectionMonitorService {
  private _isMonitoring: boolean = true;

  constructor(private eventsManagerService: EventsManagerService) {}

  public set isMonitoring(value: boolean) {
    this._isMonitoring = value;
    this.eventsManagerService.trigger(
      EventsManagerService.ON_CONNECTION_MONITOR_CHANGE,
      this._isMonitoring
    );
  }

  public get isMonitoring() {
    return this._isMonitoring;
  }
}
